import React from 'react';
import {
  ListGroupNavItem,
  SidebarNavBack,
  SidebarNavSection,
} from './ListGroupNavComponents';
import {
  useNotificationDashboardFlag,
  useNotificationJobsFlag,
} from '../../utils/featureFlags';

const NotificationsNavPanel: React.FC<{ navBack: () => void }> = ({
  navBack,
}) => {
  const notificationJobsFlag = useNotificationJobsFlag();
  const dashboardFlag = useNotificationDashboardFlag();
  return (
    <nav
      aria-label="secondary sidebar"
      className="second-panel tw:flex tw:flex-col tw:gap-1"
    >
      <SidebarNavBack title="Notifications" onBack={navBack} />
      <SidebarNavSection title="Notifications">
        <ListGroupNavItem
          to="/notifications/compose"
          icon="send"
          label="Compose"
          end
        />
        <ListGroupNavItem
          to="/notifications/sends"
          icon="mark_email_read"
          label="Sends"
          isDisabled={!dashboardFlag}
        />
        <ListGroupNavItem
          to="/scenarios"
          icon="playlist_play"
          label="Scenarios"
        />
        <ListGroupNavItem
          to="/notifications/logs"
          icon="history"
          label="Logs"
        />
        <ListGroupNavItem
          to="/notifications/jobs"
          icon="event_repeat"
          label="Alerts"
          isDisabled={!notificationJobsFlag}
        />
      </SidebarNavSection>
    </nav>
  );
};

export default NotificationsNavPanel;
